// extracted by mini-css-extract-plugin
export default {"workExperienceCard":"workExperienceCard_workExperienceCard__-gzT3","logoArea":"workExperienceCard_logoArea__NGATo","description":"workExperienceCard_description__L9DkA"};